import React from 'react';
import { motion } from 'framer-motion';
import { 
  IoLogoGithub, 
  IoLogoLinkedin, 
  IoLogoTwitter,
  IoLogoInstagram,
  IoMail, 
  IoLocation, 
  IoTime
} from 'react-icons/io5';

const Sidebar = ({ darkMode, toggleDarkMode }) => {
  const socialLinks = [
    { icon: IoLogoGithub, href: 'https://github.com/rayyanshaheer', label: 'GitHub' },
    { icon: IoLogoLinkedin, href: 'https://linkedin.com/in/rayyanshaheer', label: 'LinkedIn' },
    { icon: IoLogoTwitter, href: 'https://twitter.com/rayyanshaheer2', label: 'Twitter' },
    { icon: IoLogoInstagram, href: 'https://instagram.com/rayyan_shaheer', label: 'Instagram' }
  ];

  return (
    <motion.aside
      initial={{ x: -300 }}
      animate={{ x: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className="fixed left-0 top-0 h-full w-80 bg-bg-dark/95 backdrop-blur-xl border-r border-white-1/5 z-40 hidden lg:block overflow-y-auto"
    >
      <div className="p-8">
        {/* Profile Section */}
        <div className="text-center mb-12">
          <motion.div
            whileHover={{ scale: 1.02 }}
            transition={{ duration: 0.3 }}
            className="relative inline-block mb-8"
          >
            <img
              src="/my-avatar.jpg"
              alt="Rayyan Shaheer"
              className="w-32 h-32 rounded-2xl object-cover border border-white-1/10 mx-auto"
            />
            <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-green-400 rounded-full border-2 border-bg-dark"></div>
          </motion.div>

          <h1 className="text-xl font-semibold text-white-1 mb-1">
            Rayyan Shaheer
          </h1>
          <p className="text-accent-yellow text-sm font-medium mb-6">
            Web Developer | DevOps Engineer
          </p>

          {/* Contact Info - Always Visible */}
          <div className="mt-4 space-y-3 text-sm">
            <div className="flex items-center gap-3 text-gray-300">
              <IoMail className="text-yellow-400" size={16} />
              <span className="text-gray-200">rayyanshaheer@email.com</span>
            </div>
            <div className="flex items-center gap-3 text-gray-300">
              <IoLocation className="text-yellow-400" size={16} />
              <span className="text-gray-200">Pakistan</span>
            </div>
            <div className="flex items-center gap-3 text-gray-300">
              <IoTime className="text-yellow-400" size={16} />
              <span className="text-gray-200">GMT+5 (PKT)</span>
            </div>
          </div>
        </div>

        {/* Social Links */}
        <div className="mb-8">
          <div className="flex justify-center gap-3 flex-wrap">
            {socialLinks.map((social, index) => (
              <motion.a
                key={index}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.05, y: -1 }}
                whileTap={{ scale: 0.95 }}
                className="w-10 h-10 bg-white-1/5 rounded-lg flex items-center justify-center text-light-gray/70 hover:text-accent-yellow hover:bg-accent-yellow/10 transition-all duration-300"
                aria-label={social.label}
              >
                <social.icon size={16} />
              </motion.a>
            ))}
          </div>
        </div>
      </div>
    </motion.aside>
  );
};

export default Sidebar;
